import React from 'react';
import { useNavigate } from 'react-router-dom';

// MailVotes Pages design — brand tokens.
const NAVY = '#112030';
const GREEN = '#4CAF50';
const eyebrow = { fontSize: 12, fontWeight: 800, letterSpacing: '.13em', color: GREEN, marginBottom: 12 };
const card = { background: '#fff', border: '1px solid #e5eaf0', borderRadius: 14, boxShadow: '0 1px 3px rgba(16,42,67,.06)' };

const BENEFITS = [
  { title: 'Highly Targeted Lists', body: 'Advanced analytics ensure you reach voters most likely to support your cause and cast their vote.', path: 'M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01z' },
  { title: 'Maximize Your Budget', body: 'A focused list avoids sending materials to unlikely voters — cutting costs and improving efficiency.', path: 'M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' },
  { title: 'Up-to-Date Data', body: 'The most recent voter data available — verified and continuously updated for accuracy and freshness.', path: 'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15' },
  { title: 'Tailored to Your Needs', body: 'Swing voters, undecideds, or loyal supporters — flexible lists designed around your campaign goals.', path: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8z' },
];
const PRODUCTS = [
  { name: 'MailVotes', desc: 'Targeted voter mailing list generation and export' },
  { name: 'DoorKnock', desc: 'Mobile canvassing app for door-to-door outreach' },
  { name: 'Campaign Analytics', desc: 'Real-time insights and voter behavior analysis' },
  { name: 'Team Management', desc: 'Coordinate volunteers and track campaign progress' },
];
const STATES = ['FL', 'NC', 'PA', 'OH', 'OK', 'AR'];

function HomePage() {
  const navigate = useNavigate();
  const goVoters = () => navigate('/voters');

  return (
    <div id="mainContent" className="content-section" style={{ background: '#eef2f6', boxShadow: 'none', padding: 0, borderRadius: 0 }}>
      <div style={{ maxWidth: 1080, margin: '0 auto', padding: '36px 28px 72px' }}>

        {/* Brand bar */}
        <div style={{ ...card, display: 'flex', alignItems: 'center', gap: 16, padding: '18px 24px', marginBottom: 28, flexWrap: 'wrap' }}>
          <img src="/doornoc-logo.png" alt="Doornoc" style={{ width: 56, height: 56, objectFit: 'contain', flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: 14, color: '#475569' }}>A <b style={{ color: NAVY }}>Doornoc</b> Product</div>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>Powering Political Campaigns Nationwide</div>
          </div>
          <div style={{ flex: 1 }} />
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {STATES.map(s => (
              <span key={s} style={{ fontSize: 11, fontWeight: 700, color: '#475569', background: '#eef2f6', border: '1px solid #dfe6ee', borderRadius: 999, padding: '5px 11px' }}>{s}</span>
            ))}
          </div>
        </div>

        {/* Hero */}
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.5fr) minmax(0,1fr)', gap: 28, alignItems: 'center', marginBottom: 36 }} className="mv-hero">
          <div>
            <div style={eyebrow}>TARGETED VOTER MAILING LISTS</div>
            <h1 style={{ margin: '0 0 16px', fontSize: 40, lineHeight: 1.08, fontWeight: 900, color: NAVY }}>Maximize your political campaign's impact with custom mailing lists</h1>
            <p style={{ margin: '0 0 24px', fontSize: 16, lineHeight: 1.65, color: '#475569', maxWidth: 520 }}>Reach the right voters with targeted, high-quality mailing lists designed to maximize your campaign's budget and reach voters who are most likely to vote.</p>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
              <button onClick={goVoters} style={{ border: 'none', cursor: 'pointer', background: GREEN, color: '#fff', fontSize: 15, fontWeight: 700, borderRadius: 11, padding: '14px 28px', boxShadow: '0 4px 16px rgba(76,175,80,.35)' }}>Start building your list →</button>
              <span style={{ fontSize: 13, color: '#94a3b8' }}>Build your list in minutes with the Query Wizard</span>
            </div>
          </div>
          <div style={{ background: 'linear-gradient(160deg,#1b2c3f,#0a1420)', borderRadius: 16, padding: 28, color: '#fff', boxShadow: '0 12px 32px rgba(16,42,67,.24)' }}>
            <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.1em', color: '#7fe08a', marginBottom: 14 }}>WHAT IS MAILVOTES?</div>
            <p style={{ margin: '0 0 14px', fontSize: 14, lineHeight: 1.7, color: 'rgba(255,255,255,.85)' }}><b style={{ color: '#fff' }}>MailVotes</b> is a voter data platform by Doornoc that helps campaigns build highly targeted mailing lists — filtered by demographics, voting history, party, and geography across multiple states.</p>
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.7, color: 'rgba(255,255,255,.7)' }}>Local, state-wide, or national — MailVotes gives you the data-driven edge to connect with the voters who matter most.</p>
          </div>
        </div>

        {/* About Doornoc */}
        <div style={{ background: NAVY, color: '#fff', borderRadius: 16, padding: 32, marginBottom: 36 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
            <img src="/doornoc-logo-white.png" alt="Doornoc" style={{ height: 40, width: 'auto', objectFit: 'contain' }} />
            <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#fff' }}>About Doornoc</h2>
          </div>
          <p style={{ margin: '0 0 18px', fontSize: 15, lineHeight: 1.7, color: 'rgba(255,255,255,.8)', maxWidth: 760 }}><b style={{ color: '#fff' }}>Doornoc</b> is a political technology company empowering campaigns with cutting-edge tools and data. Our suite of products includes:</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px,1fr))', gap: 12 }}>
            {PRODUCTS.map(p => (
              <div key={p.name} style={{ background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 12, padding: '14px 16px' }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: '#fff' }}>{p.name}</div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,.65)', marginTop: 3, lineHeight: 1.5 }}>{p.desc}</div>
              </div>
            ))}
          </div>
          <p style={{ margin: '18px 0 0', fontSize: 13, color: 'rgba(255,255,255,.55)' }}>Trusted by campaigns across Florida, North Carolina, Pennsylvania, Ohio, Oklahoma, and Arkansas.</p>
        </div>

        {/* Why choose */}
        <div style={eyebrow}>WHY CHOOSE MAILVOTES?</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px,1fr))', gap: 18 }}>
          {BENEFITS.map(b => (
            <div key={b.title} style={{ ...card, padding: 22 }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke={GREEN} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d={b.path} /></svg>
              </div>
              <div style={{ fontSize: 16, fontWeight: 800, color: NAVY, marginBottom: 6 }}>{b.title}</div>
              <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, color: '#475569' }}>{b.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
